import { render, staticRenderFns } from "./VotreConsultant.vue?vue&type=template&id=2fd3c70a&"
import script from "./VotreConsultant.vue?vue&type=script&lang=coffee&"
export * from "./VotreConsultant.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VotreConsultant.vue"
export default component.exports